import PropTypes from 'prop-types';
import React from 'react';

import { BackgroundImage } from '$partials/media/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleLandscapeMedia = ({
    caption = '',
    items = []
}) => {
    return (
        <section>
            <ul>
                {items?.map((item, i) => {
                    return (
                        <li
                            className='h-dynamic-screen hide-overflow'
                            key={i}>
                            <div className='fixed inset-0'>
                                <div className='relative layout-container-landscape-media top-1/2 -translate-y-1/2'>
                                    <div
                                        className='relative rounded-r-lg sm:rounded-lg overflow-hidden aspect-video'
                                        key={i}>
                                        <BackgroundImage {...item.image} />
                                    </div>

                                    {caption && (
                                        <>
                                            {/* mobile */}
                                            <div className='flex sm:hidden'>
                                                <div className='w-sidebar' />

                                                <div className='layout-container-padding-right w-full'>
                                                    <figcaption className='layout-item-padding type-style-7 mt-15 md:mt-30 sm:w-10/12 md:w-6/12'>
                                                        {caption}
                                                    </figcaption>
                                                </div>
                                            </div>

                                            {/* desktop */}
                                            <figcaption className='hidden sm:block type-style-7 mt-15 md:mt-30 sm:w-10/12 md:w-6/12'>
                                                {caption}
                                            </figcaption>
                                        </>
                                    )}
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    caption: PropTypes.string,
    items: PropTypes.array.isRequired
};

ModuleLandscapeMedia.propTypes = propTypes;

export default ModuleLandscapeMedia;
